import { useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetTransactionsDictionariesQuery,
  useLazyGetTransactionsBaseCurrencyQuery,
  useLazyGetTransactionsCurrenciesQuery,
  useLazyGetTransactionsCountriesQuery,
  useLazyGetTransactionsRateSourceQuery,
  useLazyGetTransactionsDictionariesWithoutGLQuery,
  useLazyGetTransactionsRateSourceSettingsQuery,
} from '../../store/dictionaries/services';
import ExchangeList from './list';

import cn from './styles.module.css';

const Exchange = (): React.JSX.Element => {
  const [getDictionaries] = useLazyGetTransactionsDictionariesQuery();
  const [getDictionariesWithoutGL] =
    useLazyGetTransactionsDictionariesWithoutGLQuery();
  const [getTransactionBaseCurrency] =
    useLazyGetTransactionsBaseCurrencyQuery();
  const [getTransactionCurrencies] = useLazyGetTransactionsCurrenciesQuery();
  const [getTransactionCountries] = useLazyGetTransactionsCountriesQuery();
  const [getTransactionRateSource] = useLazyGetTransactionsRateSourceQuery();
  const [getTransactionRateSourceSettings] =
    useLazyGetTransactionsRateSourceSettingsQuery();

  const { sendMessage } = useOutletContext<{ sendMessage: SendMessage }>();

  const {
    activePermissions,
    countries,
    currencies,
    baseCurrency,
    rateSources,
    accounts,
    baseRateSettings,
    pspPartnerAccounts,
  } = useAppSelector((state) => state.transactionsDictionaries);
  const { values: transactionsTypes } = useAppSelector(
    (state) => state.settings.transactionsTypes,
  );

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.TRANSACTIONS_EXCHANGE_LIST)
    ) {
      if (!accounts) {
        getDictionaries();
      }

      if (!pspPartnerAccounts) {
        getDictionariesWithoutGL();
      }

      if (!currencies) {
        getTransactionCurrencies();
      }

      if (!countries) {
        getTransactionCountries();
      }

      if (!baseCurrency) {
        getTransactionBaseCurrency();
      }

      if (!rateSources) {
        getTransactionRateSource();
      }

      if (!baseRateSettings) {
        getTransactionRateSourceSettings();
      }
    }
  }, [
    activePermissions,
    baseCurrency,
    currencies,
    countries,
    pspPartnerAccounts,
    rateSources,
    accounts,
    baseRateSettings,
  ]);

  useEffect(() => {
    let title = 'Exchange';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.exchangeLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions && transactionsTypes) {
    if (
      activePermissions.includes(PermissionEnum.TRANSACTIONS_EXCHANGE_LIST) &&
      transactionsTypes?.find((item) => item.name === 'CURRENCY_EXCHANGE')
        ?.active
    ) {
      content = (
        <div className={cn.exchange}>
          <ExchangeList />
          <Outlet context={{ sendMessage }} />
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};

export default Exchange;
